import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BottomNav from '../components/BottomNav';
import { Button } from '../components/ui/button';
import { Store, BarChart3, Package, LogIn } from 'lucide-react';
import { KYLOO_VERSION } from '../version';

const LOGO_URL = "/logo.jpg";

export default function ShopOwnerPage() {
  const navigate = useNavigate();
  const { user, login, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // If authenticated, redirect to dashboard
  if (user) {
    navigate('/dashboard');
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-600 to-blue-700 pb-safe" data-testid="shop-owner-page">
      <main className="px-6 py-12 max-w-lg mx-auto text-center">
        {/* Logo */}
        <img src={LOGO_URL} alt="Kyloo" className="h-16 mx-auto mb-8" />

        {/* Hero */}
        <h1 className="font-outfit font-bold text-3xl text-white mb-4">
          Area Negozianti
        </h1>
        <p className="text-white/80 text-lg mb-8">
          Registrati gratuitamente e inizia a vendere i tuoi prodotti ai clienti della tua zona
        </p>

        {/* Features */}
        <div className="space-y-4 mb-10">
          <div className="flex items-center gap-4 bg-white/10 backdrop-blur rounded-2xl p-4 text-left">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <Store className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-white">Gestisci il tuo negozio</h3>
              <p className="text-white/70 text-sm">Aggiungi informazioni e posizione</p>
            </div>
          </div>

          <div className="flex items-center gap-4 bg-white/10 backdrop-blur rounded-2xl p-4 text-left">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <Package className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-white">Carica i tuoi prodotti</h3>
              <p className="text-white/70 text-sm">Foto, prezzi e disponibilità</p>
            </div>
          </div>

          <div className="flex items-center gap-4 bg-white/10 backdrop-blur rounded-2xl p-4 text-left">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <BarChart3 className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-white">Monitora le statistiche</h3>
              <p className="text-white/70 text-sm">Visualizzazioni e click sui prodotti</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <Button
          onClick={login}
          className="w-full bg-white text-blue-600 hover:bg-blue-50 py-4 rounded-xl text-lg font-semibold flex items-center justify-center gap-2"
          data-testid="login-button"
        >
          <LogIn className="w-5 h-5" />
          Accedi con Google
        </Button>

        <p className="text-white/60 text-sm mt-4">
          Versione Beta gratuita · Kyloo {KYLOO_VERSION}
        </p>
      </main>

      <BottomNav />
    </div>
  );
}
